<template>
    <v-frontend>
        <main>
            <v-header :country="country !== null ? country : ''" />
            <v-search-shortcuts />
            <v-tab />
        </main>
    </v-frontend>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            country: 'countries/country'
        })
    }
}
</script>
